import { Container, Grid, TableCell } from '@mui/material';
import { styled } from '@mui/system';

export const ComparePageHead = styled('div')`
    text-align: center;

    h2 {
        font-size: 32px;
    }

    p {
        font-size: 17px;
        margin: 0;
    }
`

export const AddressWrapper = styled('div')`
    display: flex;
    align-items: center;

    i {
        display: inline-block;
        width: 24px;
        height: 24px;
        mask: url('/images/Home.svg') 0 0 no-repeat;
        mask-size: cover;
        background-color: ${({ theme }) => theme.palette.primary.main};
        margin-right: 12px;
        flex-shrink:0;
    }
`

export const AddressDetailRow = styled('div')`
    display: flex;
    align-items: center;
    font-size: 14px;

    span {
        flex: 1;
    }
`

export const MapWarpper = styled('div')`
    height: 200px;
    background-color: #f3f3f3;
    border-radius: 12px;
    margin-top: 12px;
`

export const MapMarker = styled('div')`
    display: inline-block;
    width: 22px;
    height: 30px;
    overflow: hidden;
    background: url('/images/pin.png') 0 0 no-repeat;
    background-size: cover;
    font-size: 0;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
`
export const ACGridContentWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 12px;
    height: 100%;
    text-align: center;
    
    .price{
        font-size: 1.8rem;
        font-weight: bold;
        color: #2372B9;
        margin-bottom: 4px;
        @media(max-width:430px){
            font-size: 1.2rem;
        }
    }
    
    img{
        padding: 8px;
        max-width: 183px;
        height: auto;
        @media(max-width:430px){
            width: 100%;
            height: auto;
            padding: 4px;
        }
    }
    
    &.col-header-wrapper{
        justify-content: center;
        align-items: center;
        text-align: center;
        
        p {
            font-size: 1rem;
            font-weight: 600;
            margin: 8px 0 0 0;
            color: #333;
            line-height: 1.2;
        }
    }
    
    &.row-header-wrapper{
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
    }
    
    &.rep-header{
        background-color: #2372b9;
        height: 100%;
        color: #333;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        padding: 16px 12px !important;
        border-radius: 0;
        
        img{
            width: auto;
            // height: 60px;
            padding: 0;
            margin-bottom: 8px;
        }
        
        p {
            font-size: 1rem;
            font-weight: 600;
            margin: 0;
            color: #fff;
            line-height: 1.2;
        }
        
        @media(max-width:430px){
            padding: 12px 8px !important;
            
            img {
                height: 40px;
            }
            
            p {
                font-size: 0.9rem;
            }
        }
    }
    
    p{
        margin: 0;
        font-size: 1.3rem;
        line-height: 1.3;
        @media(max-width:430px){
            font-size: 0.8rem;
        }
    }
    
    strong{
        font-size: 1.1rem;
        font-weight: 700;
        color: #333;
        line-height: 1.3;
        @media (max-width:430px){
            font-size: 0.9rem;
        }
        @media(max-width:320px){
            font-size: 0.8rem;
        }
    }
    
    .sub-title{
        font-size: 0.9rem;
        font-weight: 400 !important;
        color: #666;
        margin-top: 4px;
        @media(max-width:430px){
            font-size: 0.7rem;
        }
    }
    
    .svg-inline--fa {
        width: 1em !important;
        font-size: 1.5rem;
        @media(max-width:430px){
            font-size: 1.2rem;
        }
    }
    
    .plan-term{
        font-weight: 700;
        color: #2372B9;
    }

    .green-circle {
        position: absolute;
        top: -2.5px;
        right: 5%;
        width: 80px;
        height: 80px;
        background-color: green;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(10deg);
        transform-origin: center;
    }
      
    .circle-content {
        text-align: center;
        color: white;
        font-size: 16px;
        line-height: 1.2;
    }
      
    .circle-content div {
        margin: 2px 0;
    }

    @media (max-width: 768px) {
        .green-circle {
            right: -10px; 
            height: 50px;
            width: 50px;
            top: 0;
        }

        .circle-content {
            text-align: center;
            color: white;
            font-size: 0.55rem;
        }
    }
`
export const ACGridItem = styled(Grid)`
    border: 1px solid #e0e0e0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 80px;
    background-color: #fff;
    
    &.col-header{
        background-color: #d1d2d4;
        border-bottom: 2px solid #e0e0e0;
        min-height: 100px;
    }
    
    &.row-header{
        background-color: #fafafa;
        border-right: 1px solid #e0e0e0;
        padding: 0 20px;
        justify-content: flex-start;
        text-align: left;
    }
    
    &.rep-column{
        background-color: #f8fbff;
    }
    
    &.constellation-column{
        background-color: #e1f0fd;
    }
    
    &.sign-up-btn{
        border: none;
        background-color: transparent;
        min-height: 100px;
        
        > div > button{
            @media(max-width:430px){
                font-size: 0.69rem !important;
            }
        }
    }

    @media (max-width: 768px) {
        min-height: 60px;
        
        &.col-header {
            min-height: 80px;
        }
        
        &.sign-up-btn {
            min-height: 80px;
        }
        
        img {
            max-width: 100%;
            margin: 0 auto;
            height: auto;
        }
    }
`
export const ACGridCell = styled(TableCell)`
    padding:0px;

`
export const ACGridContainer = styled(Container)`
    padding: 32px 24px;
    width: 100% !important;
    background-color: #fff;
    
    @media(max-width:430px){
        padding: 53px 12px;
    }
`

export const ACGrid = styled(Grid)`
  margin: auto;
  border-radius: 8px;
  overflow: hidden;
  
  
  @media (min-width: 768px){
    // max-width: 900px;
  }
`